import { gql } from '@apollo/client'

export const SHOP_CHECKOUT_SETTING_FRAGMENT = gql`
  fragment ShopCheckoutSetting on ShopCheckoutSetting {
    id
    enableGooglePay
    enableApplePay
    enableCustomTips
    enableMarketplace
    enableTips
    enableUtensils
    hideGiftCards
    hideOrderNotes
    threeDSecure
  }
`
